// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRouteState" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatClarifierExchangeGenShape } from "./chat-clarifier-exchange.gen";

export const ChatRouteStateGenShape = z.strictObject({
  tenure: z.string().optional(),
  clarifierTurns: z.number(),
  conversationId: z.string().optional(),
  clarifierHistory: z.array(ChatClarifierExchangeGenShape).optional(),
  provisionalIssues: z.array(z.string()).optional(),
  tenureClarifierTurns: z.number(),
});
